import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent {
  @Input() text: string;
  @Input() position: string = 'top';
  @Input() width: number = 250;
  @Input() fontSize: number = 14;
  @Input() color: string;
  @Input() disabledPositions: string[];
  constructor() {}
}
